export enum CommitmentSummaryStatusView {
    ACTIVE,
    OTHER_ACTIVE,
    PRE_APPROVAL,
    DRAFT,
    UPDATING,
    PENDING_CLOSE,
    CLOSED,
    OTHER_PRE_APPROVAL,
    OTHER_UPDATING,
    OTHER_PENDING_CLOSE,
}
